import { useState } from 'react';
import CommonStatus from '../../../Components/Common/CommonStatus';
import CommProfileHeader from '../../Exhibitor/Profile/CommProfileHeader';
import { useGetB2BProfile } from '../apiEndpoints/b2bBuyerSellerEndpoint';
import B2BEditProfile from '../B2BProfile/B2BEditProfile';

const B2BProfileHomePage = () => {
  const { data } = useGetB2BProfile();
  const [toggle, setToggle] = useState<boolean>(false);
  return (
    <div>
      <CommProfileHeader
        addHeadingTitle={``}
        listHeadingTitle='Profile Information'
        createBtnText='Edit Profile'
        toggle={toggle}
        setToggle={setToggle}
      />

      {toggle ? (
        <B2BEditProfile handleClose={() => setToggle(!toggle)} />
      ) : (
        <div className='profile-right-side px-3 py-3 '>
          <div className='d-flex  align-items-center justify-content-between'></div>
          <div className='profile-right-info pt-3 ps-2'>
            <ul>
              <li>
                <span>Name</span> :{' '}
                <p>
                  {data?.data?.b2b_first_name} {data?.data?.b2b_last_name}
                </p>
              </li>
              <li>
                <span>Email</span> : <p>{data?.data?.b2b_email}</p>
              </li>
              <li>
                <span>Mobile</span> : <p>{data?.data?.b2b_phone}</p>
              </li>

              {data?.data?.b2b_designation && (
                <li>
                  <span>Designation</span> :{' '}
                  <p>{data?.data?.b2b_designation}</p>
                </li>
              )}

              <li>
                <span>
                  {' '}
                  {data?.data?.b2b_id_type === 'Passport'
                    ? 'Passport No.'
                    : 'NID No.'}
                </span>{' '}
                : <p>{data?.data?.b2b_id_number}</p>
              </li>

              <li>
                <span>Organization</span> :{' '}
                <p>{data?.data?.b2b_organization}</p>
              </li>

              <li>
                <span>Business Type</span> :{' '}
                <p>{data?.data?.b2b_business_type}</p>
              </li>

              <li>
                <span>Address</span> : <p>{data?.data?.b2b_address}</p>
              </li>

              <li>
                <span>Company Brief</span> :{' '}
                <p>{data?.data?.b2b_company_brief}</p>
              </li>

              <li>
                <span>Website</span> : <p>{data?.data?.b2b_website}</p>
              </li>

              <li>
                <span>Country</span> : <p>{data?.data?.b2b_country}</p>
              </li>

              {data?.data?.b2b_telephone_number && (
                <li>
                  <span>Telephone</span> :{' '}
                  <p>{data?.data?.b2b_telephone_number}</p>
                </li>
              )}

              <li>
                <span>Status</span> :{' '}
                <p style={{ color: 'green', fontStyle: 'bold' }}>
                  {CommonStatus(data?.data?.b2b_status)}
                </p>
              </li>
            </ul>
          </div>
        </div>
      )}
    </div>
  );
};

export default B2BProfileHomePage;
